export const GIF_LIBRARY = [
  'CPskAi4C6WLHa',
  'gFwZfXIqD0eNW',
  'kaq6GnxDlJaBq',
  '2jsQhRTbZ4pdpOnANo',
  'QBd2kLB5qDmysEXre9',
  '8Aj0XP3IHJeUtcFMF0',
  'l41lVsYDBC0UVQJCE',
  'dtBi0s3hndz7q',
  '120jXUxrHF5QJ2',
  '3otPoxYilf4SYs8hpK',
  'tMNuvbHyLLXvq',
  '3oKIPbNb1vWdftiVLq',
  'ypqHf6pQ5kQEg',
  'l46CkATpdyLwLI7vi',
  'yoJC2GnSClbPOkV0eA',
  'Db3OfoegpwajK',
  'l0O9yqyFbuxZoBifu',
  'eX4DUpqQealzy',
  'l0MYt5jPR6QX5pnqM',
  'JJhiRdcYfcokU',
  '6C4y1oxC6182MsyjvK',
  'E6jscXfv3AkWQ',
  'CjmvTCZf2U3p09Cn0h',
  'pUwaR9z4BEn3q',
  'mMq8ARndQytbi',
  '9Y5BbDSkSTiY8',
  'u5eXlkXWkrITm',
  'xTiN0CNHgoRf1Ha7CM',
  '5wWf7H89PisM6An8UAU',
  'IBd4FBqsP2hWg',
  'PrCdnw7opGBa0',
  'zH6cftQTYNnZ6',
  'RddAJiGxTPQFa',
  'dOJt6XZlQw8qQ',
  'eePSFNBFv2W9owZ4Sh',
  '11ISwbgCxEzMyY',
  '14pum2mXVjzKU',
  '3og0IMJcSI8p6hYQXS',
  '6EUxr85g9rv6o',
  '1LmBFphV4XNSw',
  'm9eG1qVjvN56H0MXt8',
  'buRJVzWLzxXMI',
  'UvwI1X7XkbXq0',
  'tsgNNs93oIbwk',
  'a1QLZUUtCcgyA',
  'UO5elnTqo4vSg',
  '1JyWrrkCIUQyQ',
  'y8Mz1yj13s3kI',
  'o5oLImoQgGsKY',
  'bAlYQOugzX9sY',
  'pGOLBwYBTEvsI',
  'W80Y9y1XwiL84',
  'oyFyFiXz0hrnG',
  'bEVKYB487Lqxy',
  'XIqCQx02E1U9W',
  'rHR8qP1mC5V3G',
  'IThjAlJnD9WNO',
  't3Mzdx0SA3Eis',
  'ZaF4Vl1NQxwaVsStQU',
  'Nx0rz3jtxtEre',
  '9fuvOqZ8tbZOU',
  'xTiN0CNHgoRf1Ha7CM',
  '6yRVg0HWzgS88',
  'oOX5qIDkzDjeo',
  '90F8aUepslB84',
  'vQqeT3AYg8S5O',
  'nXxOjZrbnbRxS',
  'FoH28ucxZFJZu',
];
